export default __webpack_public_path__ + "static/media/client-inactive.33b3c7f8.svg";